import type { ContentFromSection } from "./contentItemSchemas";
import { ContentSectionType } from "@/types/contentSectionType";
import {
  contentFromSectionFieldsSchema,
  contentFromSectionSchema,
  parseWithRecord,
} from "./schemas";

export const parseContentFromSection = (
  item: unknown,
  formLabel?: string,
): ContentFromSection => {
  const parsed = parseWithRecord(item, contentFromSectionFieldsSchema);
  return contentFromSectionSchema.parse({
    type: ContentSectionType.Unknown,
    ...parsed,
    formLabel: formLabel ?? parsed.formLabel,
  });
};
